const postsSwedish = {
  header: {
    title: "Mina LinkedIn Inlägg",
    postsLeft: "{remaining}/{limit} inlägg kvar denna vecka"
  },
  limitWarning: {
    used: "Du har använt alla dina {limit} veckovisa inlägg. Uppgradera ditt abonnemang för att få fler.",
    upgrade: "Uppgradera abonnemang",
    low: "Du har {remaining} inlägg kvar denna vecka. Planera dem noggrant."
  },
  loading: "Laddar inlägg...",
  noPostsMessage: {
    title: "Inga schemalagda inlägg",
    help: "Använd Telegram-boten för att schemalägga nya inlägg"
  },
  postCard: {
    date: "{date}",
    time: "{time}",
    status: {
      scheduled: "Schemalagd",
      published: "Publicerad"
    },
    image: "Bild bifogad",
    actions: {
      share: "Dela på LinkedIn",
      sharing: "Delar...",
      delete: "Radera",
      deleting: "Raderar..."
    }
  },
  confirmation: {
    delete: "Är du säker på att du vill radera detta inlägg?"
  },
  result: {
    success: "Inlägg delat på LinkedIn!",
    errorPrefix: "Fel: ",
    postDeleted: "Inlägg borttaget!"
  },
  customerBanner: "Du visar inlägg för {customerName}",
  calendar: {
    viewToggle: {
      month: "Månad",
      week: "Vecka"
    },
    weekDays: {
      sunday: "Söndag",
      monday: "Måndag",
      tuesday: "Tisdag",
      wednesday: "Onsdag", 
      thursday: "Torsdag",
      friday: "Fredag",
      saturday: "Lördag"
    },
    weekHeader: "Vecka {week} - {month} {year}",
    noTime: "Ingen tid"
  },
  modal: {
    title: "Inläggsdetaljer",
    sections: {
      content: "Innehåll",
      schedule: "Schemalagd tid",
      status: "Status",
      image: "Bild"
    },
    schedule: {
      noTime: "Ingen tid schemalagd",
      edit: "Redigera",
      date: "Datum",
      time: "Tid",
      cancel: "Avbryt",
      save: "Spara"
    },
    status: {
      published: "Publicerad",
      ready: "Redo för publicering",
      scheduled: "Schemalagd",
      unknown: "Okänd"
    },
    actions: {
      delete: "Radera inlägg",
      share: "Dela på LinkedIn"
    }
  }
};

export default postsSwedish; 